import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiGetCall, apiPostCall } from '../utility/site-apis'
import { toast } from 'react-toastify';

const initialState = {
  isFetching: false,
  error: null,
  isOptSend: false,
  name: null,
  phone: null,
  user: null,
  token: null,
  loginRedirectUrl: null,
  contactData: null,
  celebData: null,
  isSignUp: false,
  isReferral: false,
  isReferralSend: false,
}

export const otpSend = createAsyncThunk(
  'auth/otpSend',
  async (params, { rejectWithValue }) => {
    const response = await apiPostCall(`/auth/otp/send`, params)
    if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    response.data.name = params.name
    return response.data
  }
)
export const otpReSend = createAsyncThunk(
  'auth/otpReSend',
  async (params, { rejectWithValue }) => {
    const response = await apiPostCall(`/auth/otp/resend`, params)
    if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
export const otpValidate = createAsyncThunk(
  'auth/otpValidate',
  async (params, { rejectWithValue }) => {
    const response = await apiPostCall(`/auth/otp/validate`, params)
    if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const referralValidate = createAsyncThunk(
  'auth/referralValidate',
  async (params, { rejectWithValue }) => {
    const response = await apiPostCall(`/auth/referral`, params)
    if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const contactForm = createAsyncThunk(
  'auth/contactForm',
  async (params, { rejectWithValue }) => {
    const response = await apiPostCall(`/user/contact/form`, params)
    if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
export const celebForm = createAsyncThunk(
  'auth/celebForm',
  async (params, { rejectWithValue }) => {
    const response = await apiPostCall(`/user/celeb/form`, params)
    if (response.status === 'error') {
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const counterSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoginRedirectUrl: (state, action) => {
      state.loginRedirectUrl = action.payload
    },
    setIsSignUp: (state, action) => {
      state.isSignUp = action.payload
    },
    saveNumber: (state, action) => {
      state.phone = action.payload
    },
    saveReferral: (state, action) => {
      state.isReferral = action.payload
    },
    logout: (state, action) => {
      state.user = null
      state.token = null
    },
  },
  extraReducers: {

    // contactForm
    [contactForm.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
      state.contactData = null
    },
    [contactForm.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action.payload.message
    },
    [contactForm.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      state.contactData = action.payload.data
    },
    // celebForm
    [celebForm.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
      state.celebData = null
    },
    [celebForm.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action.payload.message
    },
    [celebForm.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      state.celebData = action.payload.data
    },

    // otpSend
    [otpSend.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
      state.isOptSend = false
    },
    [otpSend.rejected]: (state, action) => {
      if (action.payload.message == 'OTP already sent, please check else resend the otp') {
        state.isOptSend = true
        state.isFetching = false
        state.name = action.payload.name
      } else if (action.payload.message == 'User Not Exist !! Please Signup') {
        state.isSignUp = true
        state.isFetching = false
        state.name = action.payload.name
      } else if (action.payload.message == 'User already exist. Please signin') {
        state.isSignUp = false
        state.isFetching = false
        state.name = action.payload.name
      } else {
        state.isFetching = false
        state.error = action.payload.message
      }
    },
    [otpSend.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      alert(action.payload.data);
      state.isOptSend = true
      state.name = action.payload.name
    },
    // otpReSend
    [otpReSend.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
      state.isOptSend = false
    },
    [otpReSend.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action.payload.message
    },
    [otpReSend.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      alert(action.payload.data);
      state.isOptSend = true
    },
    // otpValidate
    [otpValidate.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
      state.isOptSend = false
    },
    [otpValidate.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action.payload.message
    },
    [otpValidate.fulfilled]: (state, action) => {
      state.isFetching = false
      state.error = null
      state.user = action.payload.data
      state.token = `Bearer ${action.payload.data.Authorization}`
    },
    // referralValidate
    [referralValidate.pending]: (state, action) => {
      state.isFetching = true
      state.error = null
      state.isReferralSend = false
    },
    [referralValidate.rejected]: (state, action) => {
      state.isFetching = false
      state.error = action.payload.message
    },
    [referralValidate.fulfilled]: (state, action) => {
      toast.success(action.payload.data);
      state.isFetching = false
      state.error = null
      state.isReferralSend = true
    },
  }

})

export const { logout, saveReferral, setIsSignUp, saveNumber, setLoginRedirectUrl } = counterSlice.actions
export default counterSlice.reducer
